export const GRID_ROWS = 800;
export const GRID_COLS = 905;
export const TOTAL_SECTORS = GRID_ROWS * GRID_COLS; // 724,000

const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

// Convert a 3D point on the sphere surface to a sector descriptor.
// Inverse of latLngToVector3 so picked markers land exactly where clicked.
export function pointToSector(x, y, z, radius = 2) {
  const len = Math.sqrt(x * x + y * y + z * z) || 1;
  const ny = y / len;
  const phi = Math.acos(clamp(ny, -1, 1));
  const lat = 90 - (phi * 180) / Math.PI;
  let lng = (Math.atan2(z, -x) * 180) / Math.PI - 180;
  while (lng < -180) lng += 360;
  while (lng > 180) lng -= 360;
  const row = clamp(Math.floor(((90 - lat) / 180) * GRID_ROWS), 0, GRID_ROWS - 1);
  const col = clamp(Math.floor(((lng + 180) / 360) * GRID_COLS), 0, GRID_COLS - 1);
  return { row, col, sectorId: `M-${row}-${col}`, lat, lng };
}

// Convert sphere UV (from raycaster) to a sector descriptor.
export function uvToSector(u, v) {
  const lat = v * 180 - 90; // v=1 -> +90 (north)
  let lng = u * 360 - 180;
  if (lng > 180) lng -= 360;
  const row = clamp(Math.floor(((90 - lat) / 180) * GRID_ROWS), 0, GRID_ROWS - 1);
  const col = clamp(Math.floor(((lng + 180) / 360) * GRID_COLS), 0, GRID_COLS - 1);
  return { row, col, sectorId: `M-${row}-${col}`, lat, lng };
}

export function formatCoord(lat, lng) {
  const ns = lat >= 0 ? "N" : "S";
  const ew = lng >= 0 ? "E" : "W";
  return `${Math.abs(lat).toFixed(2)}\u00b0${ns}  ${Math.abs(lng).toFixed(2)}\u00b0${ew}`;
}

// lat/lng (degrees) to a unit-sphere position matching equirectangular UV mapping
export function latLngToVector3(lat, lng, radius = 1) {
  const phi = (90 - lat) * (Math.PI / 180);
  const theta = (lng + 180) * (Math.PI / 180);
  const x = -radius * Math.sin(phi) * Math.cos(theta);
  const z = radius * Math.sin(phi) * Math.sin(theta);
  const y = radius * Math.cos(phi);
  return [x, y, z];
}
